import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../contexts/LanguageContext'
import hauteImage from '../imgs/haute.png'

const NewCollectionBanner = () => {
  const { language } = useLanguage()

  return (
    <section className="relative px-4 py-16 md:py-24" style={{ 
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${hauteImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      <div className="max-w-6xl mx-auto -mt-4 md:-mt-6">
        <div className="text-center">
          <h2 className="leading-tight break-words transition-opacity" style={{ 
            fontFamily: '"Bell MT", "Georgia", serif', 
            fontSize: '1.6rem',
            color: '#F85637',
            fontWeight: '900',
            letterSpacing: '0.08em'
          }}>
            2026 Haute
            <br />
            Couture Collection
            <br />
            ANGELINA ALRICHE
            <br />
            "ALIENS from MARS"
            <br />
            for a fashion show
          </h2>
        </div>
      </div>
    </section>
  )
}

export default NewCollectionBanner
